import {
  parseTranslations,
  CommonTranslations,
  ProfilesLoginCallback,
  Sites
} from '@pmi/pmi-iqos-shared-react'
import ProfilesLoginCallbackTranslations from './profiles-login-callback.json'

ProfilesLoginCallback.componentTranslations = {
  ...ProfilesLoginCallbackTranslations,
  ...CommonTranslations
}

ProfilesLoginCallback.componentDefaultProps = {
  ...ProfilesLoginCallback.componentDefaultProps,
  translations: {
    ...parseTranslations(ProfilesLoginCallback.componentTranslations, true)
  },
  site: Sites.iqosphere
}

export default ProfilesLoginCallback
